import createVueApp from '../../shared/vue/create-app';
import initCustomControls from '../../components/custom-controls';
import _u from '../../shared/utils';
import axios from 'axios';
import {Field, Form, defineRule} from 'vee-validate';
import {required, regex} from '@vee-validate/rules';
import initEmailInput from '../../components/inputs/email-input';
import initPhoneInputComponent from '../../components/inputs/phone-input';
import '../../shared/validation-rules/rules';
import openPreviewMixin from '../../shared/vue/openPreviewMixin';
import initCustomInputsComponents from '../../components/inputs/custom-inputs';
import initServiceCardComponent from '../../components/card/service-card';

defineRule('required', required);
defineRule('regex', regex);

const initServicesPage = (opts) => {
    const app = createVueApp({ // NOSONAR
        mixins: [openPreviewMixin],
        data() {
            return {
                isBuyLocationMode: true,
            };
        },
        methods: {
        },
    });

    initServiceCardComponent(app);
    initCustomControls(app);
    initCustomInputsComponents(app);

    app.mount(opts.el);
};

const initContactUsPage = (opts) => {
    const app = createVueApp({
        mixins: [openPreviewMixin],
        data() {
            return {
                isBuyLocationMode: true,
            };
        },
        methods: {
        },
    });
    initCustomControls(app);
    initCustomInputsComponents(app);
    initEmailInput(app);
    initPhoneInputComponent(app);

    app.component('contact-us-form', {
        template: '#contact-us-form',
        props: {
            order: {
                type: String,
                required: true,
            },
            model: {
                type: Object,
                required: true,
            },
            redirectUrl: {
                type: String,
                required: true,
            },
            submitUrl: {
                type: String,
                required: true,
            },
            antiforgeryToken: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                isValidationVisible: false,
                submitting: false,
                serverError: '',
                inputPhone: {
                    entered: this.model.phoneNumber,
                    full: this.model.phoneNumber,
                },
                captchaValue: '',
            };
        },
        components: {
            VeeValidationFormContext: Form,
            ValidationField: Field,
        },
        watch: {
            'inputPhone.full'(value) {
                this.inputPhone.entered = value;
                this.inputPhone.full = value;
            },
        },
        methods: {
            startFormSubmit() {
                this.submitting = true;
            },
            stopFormSubmit() {
                this.submitting = false;
            },
            showValidation() {
                this.isValidationVisible = true;
            },
            async submitFormAsync() {
                this.startFormSubmit();
                this.showValidation();

                if (await this._validate()) {
                    await this.createOrderAsync();
                } else {
                    this.stopFormSubmit();
                }
            },
            async createOrderAsync() {
                const requestConfig = _u.createRequestConfig(this.antiforgeryToken);
                const contactUsModel = Object.assign(this.model);
                contactUsModel.phoneNumber = this.inputPhone.full;

                try {
                    const response = await axios.post(this.submitUrl, contactUsModel, requestConfig);
                    if (response.status >= 200 && response.status < 300) {
                        this.$refs.form.submit();
                    } else {
                        this.stopFormSubmit();
                    }
                } catch (error) {
                    this.serverError = error.response.data;

                    this.stopFormSubmit();
                    this.showValidation();
                }
            },
            async _validate() {
                const validator = this.$refs.validator;
                const result = await validator.validate();

                return result.valid;
            },
        },
    });

    app.mount(opts.el);
};

export {initServicesPage, initContactUsPage};
